import { useTranslation } from 'react-i18next';
import Skeleton from 'react-loading-skeleton';
import LoaderMain from './LoaderMain';
import { FC } from 'react';

interface PaymentSkeletonProps {
  systemProducts:
    | 'Dynamic_FMHM'
    | 'Dynamic'
    | 'Hotels'
    | 'Flights'
    | 'Transfers'
    | 'Nofshon'
    | 'Tours';
  showPaymentLoader?: boolean;
}

const PaymentSkeleton: FC<PaymentSkeletonProps> = ({ systemProducts, showPaymentLoader }) => {
  const { t } = useTranslation();
  return (
    <div className="pay-wrapper">
      <div className="pay-body">
        <div className="pay-0">
          <div style={{ height: 40, width: '100%' }}>{t('')}</div>
        </div>
        <div className="pay-2">
          <div style={{ width: '49%' }}>
            <Skeleton width="100%" height="40px" />
          </div>
          <div style={{ width: '49%' }}>
            <Skeleton width="100%" height="40px" />
          </div>
        </div>
        <div className="pay-3">
          <Skeleton height="40px" width="100%" style={{ borderRadius: 6, marginBottom: 12 }} />
        </div>
        <div className="pay-2 pay-21">
          <div style={{ width: '49%' }}>
            <Skeleton width="100%" height="40px" />
          </div>
          <div style={{ width: '49%' }}>
            <Skeleton width="100%" height="40px" />
          </div>
        </div>
        <div className="pay-4">
          <Skeleton width="100%" height="40px" style={{ borderRadius: 6, marginBottom: 12 }} />
        </div>
        <div className="pay-5">
          <Skeleton width="100%" height="36px" style={{ borderRadius: 6, marginBottom: 12 }} />
        </div>
        <div className="pay-6">
          <Skeleton width="100%" height="36px" style={{ borderRadius: 6, marginBottom: 33 }} />
        </div>
        <div className="pay-7">
          <Skeleton width="100%" height="58px" style={{ borderRadius: 6, marginBottom: 0 }} />
        </div>
      </div>
      {showPaymentLoader && (
        <LoaderMain systemProducts={systemProducts} systemProductsDetails="LoadingBook" />
      )}
    </div>
  );
};

export default PaymentSkeleton;
